import { render, staticRenderFns } from "./BasicPaginator.vue?vue&type=template&id=d2a52a26&"
import script from "./BasicPaginator.vue?vue&type=script&lang=js&"
export * from "./BasicPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports